import { useRef, useEffect, useState } from "react";
import CarouselProduct from "./CarouselProduct.jsx";
import { ChervonLeft, ChervonRight } from "./Icon.jsx";

const Carousel = ({ products, align, width, carouselClass, productWidth, productMinWidth, buttonWidth, productHeight }) => {
  const [sortedProducts, setSortedProducts] = useState([])
  const [buttonsActive, setButtonsActive] = useState(false)
  const [isDown, setIsDown] = useState(false)
  const [startX, setStartX] = useState(null)
  const [activeSlide, setActiveSlide] = useState(0)
  const [scrollLft, setScrollLft] = useState(null)
  const [scrollActive, setScrollActive] = useState(false)
  const carouselRef = useRef(null);
  const carouselItemRefs = useRef([]);


  const activateDragScroll = (e) => {
    setIsDown(true)
    setStartX(e.pageX - carouselRef.current.offsetLeft)
    setScrollLft(carouselRef.current.scrollLeft)
  }

  const deactivateDragScroll = () => {
    setIsDown(false)
  }

  const onDragScroll = (e) => {
    if (!isDown) return 
    e.preventDefault()
    const x = e.pageX - carouselRef.current.offsetLeft
    const slide = (x - startX) * 3
    carouselRef.current.scrollLeft = scrollLft - slide
  }

  const scrollRight = (e) => {
    e.preventDefault();
    const scrollAmount = carouselRef.current.clientWidth;
    requestAnimationFrame(() => {
      carouselRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    });
  };

  const scrollLeft = (e) => {
    e.preventDefault();
    const scrollAmount = -carouselRef.current.clientWidth;
    requestAnimationFrame(() => {
      carouselRef.current.scrollBy({
        left: scrollAmount,
        behavior: "smooth",
      });
    });
  };

  const handleIntersect = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const index = carouselItemRefs.current.indexOf(entry.target)
        setActiveSlide(index)
      }
    })
  }

  useEffect(() => {
    const snapContainer = carouselRef.current;
    const snapElements = carouselItemRefs.current.filter((el) => el);

    if (!snapContainer || !snapElements.length) {
      return;
    }

    const observer = new IntersectionObserver(handleIntersect, {
      root: snapContainer,
      threshold: 1,
    });

    snapElements.forEach((snapElement) => {
      observer.observe(snapElement);
    });
    
    return () => {
      observer.disconnect();
    };
  }, [products?.length]);

  
  return (
    <div className={`${width} flex justify-center items-center gap-10 flex-col md:my-10 my-5 relative mx-auto bg-transparent`}>
      <div
        onMouseEnter={() => {
          setButtonsActive(true)
        }}
        onMouseLeave={() => {
          setButtonsActive(false)
        }}
        className={
          products?.length >= 4
            ? `${buttonsActive ? 'opacity-100' : 'opacity-0'} transition-opacity duration-300 laptop:flex hidden ${buttonWidth} xl:max-w-[1220px] w-full justify-between items-center absolute pointer-events-none z-10`
            : "hidden"
        }
      >
        <button
          onClick={(e) => scrollLeft(e)}
          className={`${scrollActive && activeSlide > 0 ? 'visible' : 'invisible' } w-6 h-6 hover:bg-[#BABDC4] bg-[#570054] hover:text-black text-white transition-all cursor-pointer grid place-items-center rounded-full shadow-sm pointer-events-auto`}
        >
          <ChervonLeft />
        </button>
        <button
          onClick={(e) => scrollRight(e)}
          className={`${activeSlide === products?.length - 1 ? 'invisible' : 'visible' } w-6 h-6 hover:bg-[#BABDC4] bg-[#570054] hover:text-black text-white transition-all cursor-pointer grid place-items-center rounded-full shadow-sm pointer-events-auto`}
        >
          <ChervonRight />
        </button>
      </div>
      <div
        onMouseEnter={() => {
          setButtonsActive(true)
        }}
        onMouseLeave={() => {
          setButtonsActive(false)
          deactivateDragScroll()
        }}
        onMouseDown={(e) => {
          activateDragScroll(e)
        }}
        onMouseUp={() => {
          deactivateDragScroll()
        }}
        onMouseMove={(e) => {
          onDragScroll(e)
        }}
        onScroll={() => setScrollActive(true)}
        className={`${carouselClass} ${products?.length >= 4 ? 'justify-start' : 'lg:justify-center' } transition-all scroll-smooth cursor-grabbing`}
          ref={carouselRef}
        >
          {products?.length > 0 && products?.map((product, index) => {
            return (
              <div ref={(el) => carouselItemRefs.current[index] = el} key={product.handle}>
                <CarouselProduct
                  product={product}
                  align={align}
                  productWidth={productWidth}
                  productMinWidth={productMinWidth}
                  productHeight={productHeight}
                />
              </div>
            );
          })}
        </div>
    </div>
  );
};

export default Carousel;
